import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { functions } from '../firebase';
import { httpsCallable } from 'firebase/functions';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import NavBar from '../Components/NavBar';

const RequestTeam = () => {
  const [teamName, setTeamName] = useState('');
  const [requestType, setRequestType] = useState('team');
  const [playerName, setPlayerName] = useState('');
  const [contactName, setContactName] = useState('');
  const [playerEmail, setPlayerEmail] = useState('');
  const [contactEmail, setContactEmail] = useState('');
  const [isSub, setIsSub] = useState(false);
  const [note, setNote] = useState('');
  const [status, setStatus] = useState(null);
  const [statusMessage, setStatusMessage] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');
    setStatusMessage('');

    try {
      const trimmedTeamName = teamName.trim();
      if (!trimmedTeamName) {
        setStatus('error');
        setStatusMessage('Team name is required.');
        return;
      }

      const requestPayload = {
        requestType,
        teamName: trimmedTeamName,
        note: note.trim(),
        status: 'pending'
      };

      if (requestType === 'player') {
        if (!playerName.trim() || !playerEmail.trim()) {
          setStatus('error');
          setStatusMessage('Player name and email are required for a player request.');
          return;
        }

        requestPayload.playerName = playerName.trim();
        requestPayload.playerEmail = playerEmail.trim();
        requestPayload.isSub = isSub;
      } else {
        if (!contactName.trim() || !contactEmail.trim()) {
          setStatus('error');
          setStatusMessage('Your name and email are required for a team request.');
          return;
        }

        requestPayload.contactName = contactName.trim();
        requestPayload.contactEmail = contactEmail.trim();
      }

      const submitTeamRequest = httpsCallable(functions, 'submitTeamRequest');
      await submitTeamRequest(requestPayload);
      setStatus('success');
      setStatusMessage('Request submitted — an admin will review it shortly.');
      setTeamName('');
      setContactName('');
      setContactEmail('');
      setPlayerName('');
      setPlayerEmail('');
      setIsSub(false);
      setNote('');
    } catch (err) {
      console.error('RequestTeam submit error', err);
      setStatus('error');
      setStatusMessage(err.message || 'Failed to submit request. Try again later.');
    }
  }

  return (
    <>
      <NavBar pageName="Request Team/Player" showMenu={false} />
      <Container className="my-4">
        <Button variant="secondary" className="mb-3" onClick={() => navigate('/')}>Back to Login</Button>
        <Row>
          <Col md={8} lg={6} className="mx-auto">
            <Card>
              <Card.Body>
                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                    <Form.Label>Request Type</Form.Label>
                    <Form.Select value={requestType} onChange={(e) => setRequestType(e.target.value)}>
                      <option value="team">New team</option>
                      <option value="player">New player</option>
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Team Name</Form.Label>
                    <Form.Control required value={teamName} onChange={(e) => setTeamName(e.target.value)} placeholder="e.g. Springfield Sluggers" />
                  </Form.Group>

                  {requestType === 'player' ? (
                    <>
                      <Form.Group className="mb-3">
                        <Form.Label>Player Name</Form.Label>
                        <Form.Control required value={playerName} onChange={(e) => setPlayerName(e.target.value)} placeholder="Player Name" />
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <Form.Label>Player Email</Form.Label>
                        <Form.Control required type="email" value={playerEmail} onChange={(e) => setPlayerEmail(e.target.value)} placeholder="player@example.com" />
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <Form.Check type="checkbox" label="Is Sub" checked={isSub} onChange={() => setIsSub(!isSub)} />
                      </Form.Group>
                    </>
                  ) : (
                    <>
                      <Form.Group className="mb-3">
                        <Form.Label>Your Name</Form.Label>
                        <Form.Control required value={contactName} onChange={(e) => setContactName(e.target.value)} />
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <Form.Label>Your Email</Form.Label>
                        <Form.Control required type="email" value={contactEmail} onChange={(e) => setContactEmail(e.target.value)} />
                      </Form.Group>
                    </>
                  )}

                  <Form.Group className="mb-3">
                    <Form.Label>Notes (optional)</Form.Label>
                    <Form.Control as="textarea" rows={3} value={note} onChange={(e) => setNote(e.target.value)} />
                  </Form.Group>

                  <div className="d-flex gap-2">
                    <Button type="submit" variant="primary" disabled={status === 'loading'}>Send Request</Button>
                  </div>

                  {status === 'success' && <div className="mt-3 text-success">{statusMessage || 'Request submitted — an admin will be notified.'}</div>}
                  {status === 'error' && <div className="mt-3 text-danger">{statusMessage || 'Failed to submit request. Try again later.'}</div>}
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default RequestTeam;
